import 'utils/ajax_form';

import './index.scss';
import { handleApiError } from 'utils/api_error_handler';

class FeedbackForm {
  constructor(context) {
    const $element = $('.js-feedback-form', $(context));

    if (!$element.length) {
      return;
    }

    this.$component = $($element.get(0));
    this.$likeButtons = $('.q-likes-btn', this.$component);
    this.$likeInputs = $(
      `[name="${this.config.resourceKey}[reaction]"]`,
      this.$component
    );
    this.$cancelButton = $('.js-cancel-btn', this.$component);
    this.$answerField = $('#js-answer-field', this.$component);

    this.bind();
  }

  get config() {
    return this.$component.data();
  }

  swapAnswerFieldClasses(e) {
    const inputValue = e.currentTarget.value;
    this.reaction = this.getReaction(inputValue);
    const isLikeReaction = this.reaction === 'liked';

    this.$answerField.removeClass('q-answer--dislike q-answer--like')

    if (isLikeReaction) {
      !this.feedbackId && this.sendFeedback();
      this.$answerField.addClass('q-answer--like').show();
      return
    }

    this.$answerField.addClass('q-answer--dislike').show();
  }

  bind() {
    this.$likeInputs.on('change', (e) => {
      this.swapAnswerFieldClasses(e);
    });

    this.$component
      .ajaxForm(false)
      .lazyReady()
      .on('submit', (e) => {
        e.preventDefault();
        this.sendFeedback();
        return false;
      });

    this.$cancelButton.on('click', () => {
      this.$likeInputs.prop('checked', false);
      this.$answerField.hide();
    });
  }

  getReaction(reaction) {
    const list = {
      1: 'liked',
      2: 'disliked'
    };

    return list[reaction];
  }

  setReactionButtonAsMarked(isLikeReaction) {
    const buttonSelector = isLikeReaction ? '.q-like' : '.q-dislike';

    const $buttonElement = $(buttonSelector, this.$component).find('.q-icon');

    const { classToAdd, classToRemove } = $buttonElement.data();

    if (classToAdd && classToRemove) {
      $buttonElement.addClass(classToAdd);
      $buttonElement.removeClass(classToRemove);
    }
  }

  updateFeedback(){
    this.thorResource.update(
        { id: this.feedbackId },
        {
          data: this.feedbackContent
        }
      )
      .then(() => {
        this.handleFeedbackSuccess();
        this.$answerField.hide();
      }).catch(({ response }) => {
        this.handleError(response);
      });
  }

  setFeedbackData(){
    this.feedbackContent = this.$component.serializeObject();
    this.thorResource = Thor[this.config.resourceName];
  }

  handleError(err){
    handleApiError(null, err);
    this.$component.trigger('ajax:error');
    this.$likeButtons.attr('disabled', false);
  }

  handleFeedbackSuccess(){
    this.$component
    .clearForm()
    .trigger('ajax:success')
    .addClass('q-feedback-form--replied')
    .data('replied', true);

    this.$likeInputs.remove();

    this.$likeButtons.attr({
      title: this.config.alreadyRepliedMessage,
      'data-toggle': 'tooltip',
      disabled: false
     });
    this.$likeButtons.removeAttr('for');
  }

  updateCounterValue(){
    const isLikeReaction = this.reaction === 'liked';
    const counterSelector = `.js-${isLikeReaction ? 'likes' : 'dislikes'}-count`;
    const $counter = $(counterSelector, this.$component);
    const currentValue = parseInt($counter.html());

    this.setReactionButtonAsMarked(isLikeReaction);
    $counter.html(currentValue + 1);
  }

  sendFeedback() {
    this.setFeedbackData();

    if (!this.thorResource) {
      throw Error(`Model '${this.config.resourceName}' not found in Thor.`);
    }

    this.$likeButtons.attr('disabled', true);

    if(this.feedbackId){
      return this.updateFeedback();
    }

    this.thorResource.create({},
        {
          data: this.feedbackContent
        }
      )
      .then((data) => {
        this.feedbackId = data.id;
        this.handleFeedbackSuccess();
        this.updateCounterValue();
      })
      .catch(({ response }) => {
        this.handleError(response);
      });
  }
}

export default FeedbackForm;
